import InstallmentRequests from "app/api/installment";
import { handleGenericApiError } from "app/api/error";
import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_INSTALLMENTS = "installment:ACTION_SAVE_INSTALLMENTS";

export const fetchInstallments = params => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await InstallmentRequests.fetchInstallments(params);
    dispatch({ type: ACTION_SAVE_INSTALLMENTS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchAllInstallments = params => async () => {
  try {
    return await InstallmentRequests.fetchInstallments(params);
  } catch (err) {
    handleGenericApiError(err);
  }
};
